import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;
const PUBLIC_API_URL = process.env.REACT_APP_CHANNEL_PUBLIC_API_PATH;

export const getSystemsData = () =>
  axios.get(`${API_HOST}/shops/connect-system`, { withCredentials: true });

export const getListShashokuUserData = params =>
  axios.get(`${API_HOST}/shashoku/users`, {
    withCredentials: true,
    params
  });

export const getListShopShashokuData = params =>
  axios.get(`${PUBLIC_API_URL}/share/shops`, {
    withCredentials: false,
    params
  });

export const getListMenuShashokuData = (shopId, params) =>
  axios.get(`${PUBLIC_API_URL}/share/shops/${shopId}`, {
    params,
    withCredentials: false
  });

export const changesystemInvoiceRateData = (systemId, params) =>
  axios.put(
    `${API_HOST}/shashoku-budgets/system-invoice-rate/${systemId}`,
    params,
    {
      withCredentials: true
    }
  );

export default getSystemsData;
